<template>
<div>
    <!-- Header -->
    <base-header class="pb-6 pb-4 pt-5 pt-md-6 text-center">
        <!-- <h2 class="display-4">DASHBOARD PERAKU</h2> -->
    </base-header>
    &nbsp;
    <!-- Container Utama -->
    <b-container fluid class="">
        <card header-classes="bg-transparent">
            <b-row class="mb-4">
                <b-col cols="12">
                    <h4 class="text-primary">CARIAN PEGAWAI</h4>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <!-- Carian Pengguna -->
                    <div class="card-wrapper shadow-lg mb-4">
                        <card class="border-0">
                            <b-row class="my-1">
                                <b-col sm="3" class="font-weight-bold">NO KAD PENGENALAN</b-col>
                                <b-col sm="5">
                                    <b-form-input v-model="form.NoKP" class="rounded"></b-form-input>
                                </b-col>
                                <b-button variant="primary" @click="carian" class="ml-2">CARIAN</b-button>
                            </b-row>
                        </card>
                    </div>
                </b-col>
            </b-row>

            <!-- Maklumat Penjawat Awam -->
            <div v-if="this.status.rcode == 0">
                <validation-observer v-slot="{ invalid }">
                    <b-form @submit.prevent="SimpanMaklumat">
                        <card header-classes="bg-transparent shadow-sm">
                            <h4 class="mb-0 text-center text-primary">Maklumat Pegawai</h4>
                            <hr />
                            <div class="pl-lg-4">
                                <!-- No. Kad Pengenalan -->
                                <validation-provider name="NoKP" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">No. Kad Pengenalan</b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="8">
                                            <b-form-input v-model="ProfilAwam.NoKP" disabled class="rounded"></b-form-input>
                                            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <!-- Nama -->
                                <validation-provider name="NAMA" :rules="{ required: true }" v-slot="validationContext">
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">Nama</b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="8">
                                            <b-form-input v-model="ProfilAwam.Nama" :state="getValidationStatePenjawat(validationContext)" disabled class="rounded"></b-form-input>
                                            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <!-- Klasifikasi Perkhidmatan Pertama -->
                                <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }" >
                                    <b-row>
                                        <b-col lg="3" class="font-weight-bold"> Klasifikasi Perkhidmatan Pertama* </b-col>
                                        <b-col lg="1"> :</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 50%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row>
                                    <b-col sm="1">&nbsp;</b-col>
                                </b-row>
                                <validation-provider name="Skim Perkhidmatan" :rules="{ required: true }" >
                                    <b-row>
                                        <b-col lg="3" class="font-weight-bold"> Skim Perkhidmatan Pertama* </b-col>
                                        <b-col lg="1"> :</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.SchmOfServId" :options="SchmOfServList" @change="runMethod2()" style="width: 80%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row class="my-1">
                                    <b-col sm="1">&nbsp;</b-col>
                                </b-row>
                                <validation-provider name="Gred Jawatan Lantikan Pertama" :rules="{ required: true }" >
                                    <b-row class="my-1">
                                        <b-col lg="3" class="font-weight-bold"> Gred Jawatan Pertama* </b-col>
                                        <b-col lg="1">:</b-col>
                                        <b-col lg="8">
                                            <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ProfilAwam.SalGrdID" :options="SalGrdList" style="width: 40%" aria-describedby="input-2-live-feedback">
                                                <template #first>
                                                    <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                                                </template>
                                            </b-form-select>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                                <b-row class="my-1">
                                    <b-col sm="1">&nbsp;</b-col>
                                </b-row>
                                <validation-provider name="Gaji Lantikan Pertama" :rules="{ required: true }" >
                                    <b-row class="my-1">
                                        <b-col lg="3" class="font-weight-bold">Gaji Lantikan Pertama* </b-col>
                                        <b-col lg="1">:</b-col>
                                        <b-col lg="4">
                                            <b-form-input v-model="ProfilAwam.SalGrdPertama" ></b-form-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <!-- Tarikh Lantikan Pertama -->
                                <validation-provider name="Tarikh Lantikan Pertama" :rules="{ required: true }" >
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">Tarikh Lantikan Pertama</b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">
                                            <b-form-input type="date" v-model="ProfilAwam.DtLantikanPertama" size="sm" class="rounded shadow-sm"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>

                                <!-- Tarikh Dijangka Bersara -->
                                <validation-provider name="Tarikh Dijangka Bersara" :rules="{ required: true }">
                                    <b-row class="my-3">
                                        <b-col sm="3" class="font-weight-bold">Tarikh Dijangka Bersara</b-col>
                                        <b-col sm="1">:</b-col>
                                        <b-col sm="4">
                                            <b-form-input type="date" v-model="ProfilAwam.DtJangkaPencen" size="sm" class="rounded shadow-sm"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </validation-provider>
                            </div>

                            <!-- Butang Simpan -->
                            <b-row class="justify-content-center mt-4">
                                <b-button variant="success" type="submit" :disabled="invalid" v-show="simpa2" class="px-5">SIMPAN</b-button>
                            </b-row>
                        </card>
                    </b-form>
                </validation-observer>
            </div>
        </card>
    </b-container>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
import GetsalaryService from "@/services/salaryService.js";
import swal from "sweetalert2";
export default {
    data() {
        return {
            StatusMeninggalDunia: 0,
            StatusKGT2023: 1,
            form: {
                NoKP: this.NoKP,
            },
            statuspemanggil: {
                Status: 2,
            },
            status: {},
            ProfilAwam: {
                //StatusKGT2023: 1,
                // Nama: null,
            },
            selectedKlasPerkhidmatan: null,
            selectedSkimPerkhidmatan: null,
            selectedSalGrd: null,
            ServClassList: [{
                    value: 1,
                    text: "test 1",
                },
                {
                    value: 2,
                    text: "test 2",
                },
            ],
            StatusNokp: {},
            SchmOfServList: [],
            SalGrdList: [],
            active: false,
            simpa2: true,
            options: [{
                    text: "YA",
                    value: "1",
                },
                {
                    text: "TIDAK",
                    value: "0",
                },
            ],
        };
    },
    methods: {
        getValidationStatePenjawat({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },
        carian() {
            this.simpa2 = true;
            this.active = false;

            let Search = {
                NoKP: this.form.NoKP,
                //NoKP: 860610565253,
            };

            GetsalaryService.getMaklPenjawatAwamServ(Search)
                .then((resp) => {
                    this.status = resp.data;
                    this.ProfilAwam = this.status.table.response;
                    console.log("ini msg", resp.data);
                    // console.log("ini data",this.ProfilAwam);
                    this.ProfilAwam.DtLantikanPertama = moment(
                        this.ProfilAwam.TarikhLantikan,
                        "YYYY-MM-DD"
                    ).format("YYYY-MM-DD");
                    this.ProfilAwam.DtJangkaPencen = moment(
                        this.ProfilAwam.TarikhJangkaBersara,
                        "YYYY-MM-DD"
                    ).format("YYYY-MM-DD");
                    this.ProfilAwam.StatusKGT2023 = 1;
                    this.ProfilAwam.SalGrdPertama = this.ProfilAwam.GajiLantikan;
                    this.ProfilAwam.SalGrdID = this.ProfilAwam.IDGredGaji;
                    console.log("ini data", this.ProfilAwam);

                    if (this.status.rcode == 9) {
                        swal.fire({
                            title: `No Kad Pengenalan Bukan Penjawat Awam.`,
                            buttonsStyling: true,
                            icon: "warning",
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    swal.fire({
                        title: `No Kad Pengenalan Bukan Penjawat Awam.`,
                        buttonsStyling: true,
                        icon: "warning",
                    });
                });
        },
        runMethod() {
            console.log("klas perkhidmatan", this.ServClassId);

            let Search = {
                ServClassId: this.ProfilAwam.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {

            let Search = {
                ServClassId: this.ProfilAwam.ServClassId,
                SchmOfServId: this.ProfilAwam.SchmOfServId,
            };

            console.log("search", this.Search);

            GetselenggaraService.getSenaraiSalGrd(Search)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        SimpanMaklumat() {
            console.log("ProfilAwam", this.ProfilAwam);

            let Search = {
                NoKP: this.form.NoKP,
                //NoKP: 860610565253,
            };

            GetsalaryService.getStatusNOKp(Search)
                .then((resp) => {
                    this.StatusNokp = resp.data;
                    console.log("this.StatusNokp.Status", this.StatusNokp.Status);

                    if (this.StatusNokp.Status == 1) {
                        const swalWithBootstrapButtons = swal.mixin({
                            customClass: {
                                confirmButton: "btn btn-success",
                                cancelButton: "btn btn-danger",
                            },
                            buttonsStyling: false,
                        });
                        //console.log("Memanggil swal.fire...");
                        swalWithBootstrapButtons
                            .fire({
                                title: "ADAKAH ANDA PASTI?",
                                text: " No Kad Pengenalan Telah Wujud, Teruskan?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonText: "YA, TERUSKAN JANA",
                                cancelButtonText: "BATAL",
                                reverseButtons: true,
                            })
                            .then((result) => {
                                console.log("Hasil SweetAlert:", result);
                                if (result.isConfirmed) {
                                    console.log("Menghantar data ke servis...");
                                    GetsalaryService.setMaklPenjawatAwam(this.ProfilAwam)
                                        .then((resp) => {
                                            console.log("Servis berjaya:", resp);
                                            //this.simpanbutiran();
                                            swalWithBootstrapButtons
                                                .fire({
                                                    title: "BERJAYA DI SIMPAN!",
                                                    text: "KLIK OK UNTUK TERUSKAN.",
                                                    icon: "success",
                                                })
                                                .then(() => {
                                                    this.$router.push({
                                                        name: "BUTIRAN MAKLUMAT PERIBADI",
                                                        params: {
                                                            ICNo: this.ProfilAwam.NoKP,
                                                        },
                                                    });
                                                });
                                        })
                                        .catch((err) => {
                                            console.log("err:", err.response);
                                        });
                                } else if (
                                    /* Read more about handling dismissals below */
                                    result.dismiss === swal.DismissReason.cancel
                                ) {
                                    swalWithBootstrapButtons
                                        .fire({
                                            title: "BATAL",
                                            text: " Proses Janaan Maklumat Pegawai Dibatalkan.",
                                            icon: "error",
                                        })
                                        .then(() => {
                                            this.$router.push({
                                                name: "DASHBOARD KIRAAN GAJI",
                                                // params: {
                                                //     ICNo: this.ProfilAwam.NoKP,
                                                // },
                                            });
                                        });
                                }
                            });
                    } else if (this.StatusNokp.Status == 2) {
                        GetsalaryService.setMaklPenjawatAwam(this.ProfilAwam)
                            .then((resp) => {
                                swal
                                    .fire({
                                        title: "BERJAYA DI SIMPAN!",
                                        text: "CLICK OK UNTUK TERUSKAN.",
                                        icon: "success",
                                    })
                                    .then(() => {
                                        this.$router.push({
                                            name: "BUTIRAN MAKLUMAT PERIBADI",
                                            params: {
                                                ICNo: this.ProfilAwam.NoKP,
                                            },
                                        });
                                    });
                            })
                            .catch((err) => {
                                console.log("err:", err.response);
                            });
                    } else {
                        swal.fire({
                            title: `MASALAH DATABASE @ NETWORK.`,
                            buttonsStyling: true,
                            icon: "error",
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });

            // this.$store.commit('clearAll');
            // this.ProfilAwam.StatusMeninggalDunia = this.StatusMeninggalDunia;
            // this.$store.commit("addMaklumatPeribadi", this.ProfilAwam);

            // this.$router.push({
            //     name: 'BUTIRAN MAKLUMAT PERIBADI',
            //     params: {
            //         ICNo: this.ProfilAwam.NoKP,
            //     }
            // })

            /*ini bila dah join dengan backend */
            // GetsalaryService.setTambahMaklPer(this.ProfilAwam).then((resp) => {

            //         swal
            //             .fire({
            //                 title: `Operasi Berjaya.`,
            //                 buttonsStyling: true,
            //                 icon: "success",
            //             })
            //             .then(() => {
            //                 this.$router.push({
            //                     name: 'MAKLUMAT ADUAN',
            //                     params: {
            //                         NoKP: this.form.NoKP,
            //                         notelAvaya: this.notelAvaya,
            //                         nama: this.form.Nama
            //                     }
            //                 });
            //             });
            //     })
            //     .catch((err) => {
            //         console.log("err:", err.response);
            //     });
        },
        // simpanbutiran() {
        //   let Search = {
        //     NoKP: this.form.NoKP,
        //     //NoKP: 860610565253,
        //   };

        //   GetsalaryService.setElemen(Search)
        //     .then((resp) => {
        //       swal.fire({
        //         title: "BERJAYA DI SIMPAN!",
        //         text: "CLICK OK UNTUK TERUSKAN.",
        //         icon: "success",
        //       });
        //     })
        //     .catch((err) => {
        //       console.log("err:", err.response);
        //     });
        // },
    },
    created() {
        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log("SERVE",this.ServClassList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSchmOfServ()
            .then((resp) => {
                this.SchmOfServList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getSenaraiSalGrd()
            .then((resp) => {
                this.SalGrdList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });
    },
};
</script>

<style scoped>
/* Optional: Customize styles for better aesthetics */
h4 {
    font-weight: 600;
    text-transform: uppercase;
}

.stats-card2 {
    transition: transform 0.3s;
}

.stats-card2:hover {
    transform: scale(1.05);
    /* Scale up on hover */
}

.base-button {
    transition: background-color 0.3s;
}

.base-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
    /* Slight change on hover */
}
</style>
